import React, { useState, useEffect, useRef, useContext } from 'react';
import { s3Static } from '../../utils/constants';
import { FaChevronDown } from 'react-icons/fa';
import { NativeAppSignIn } from './NativeAppSignIn';
import Link from 'next/link';
import { LoadingCover } from '../commons/LoadingCover';
import { LocationContext } from '../../context/LocationContext';
import { useRouter } from 'next/router'

export const TopBanner = () => {  
  const router = useRouter()

  const routeCountryCd = router.query.countryCd

  const routeLocality = router.query.locality

  const videoRef = useRef();

  const [ isNativeApp, setIsNativeApp ] = useState(false);
  const [ isLoading, setIsLoading ] = useState(false)

  const { countryCd, locality } = useContext(LocationContext)

  useEffect(() => {    
    videoRef.current.play()
  }, [])

  return (
    <>
      <div id="web-app" style={{height: "700px"}} className="-mt-14 relative w-full aspect-video overflow-hidden bg-black">
        <video
            ref={videoRef}
            id="vid"
            className="absolute w-full h-full object-cover opacity-50"
            poster={s3Static + "index.jpg"}
            muted
            loop
            playsInline
            preload="auto"
            loading="eager"
        >
          <source src="/video/main-least.mp4" />
          <source src="/video/main-least.mov" />
        </video>

        {/* Content */}
        <div className="absolute top-1/4 w-full text-center z-10 px-5">
          <span className="text-amber-400 font-bold text-4xl">
            Strings<span className="text-slate-400">SG</span>
          </span>
          <div className="pt-5">
            <span className="text-white text-2xl px-2">
              Your connection to professional services
            </span>
          </div>
        </div>

        <div className="absolute bottom-[15%] w-full text-center z-10 px-5">
          {/* ✅ LCP Element - Ensure font is loaded early */}
          <h1 className="mb-2 text-white text-base font-semibold">
            Aircon Servicing, Personal Trainer, Handyman, Financial Adviser, Property agent and more!
          </h1>
          <FaChevronDown className="text-white mx-auto animate-bounce mt-1" />
          <div className="relative flex justify-center mt-3">
            <Link
              href="/#service-list"
              prefetch={false}
              className="px-8 py-3 border-2 border-white text-white rounded-full text-xl"
            >
              {!countryCd && !routeCountryCd ? (
                <div className="p-2 flex justify-center">
                  <div className="loader">Loading...</div>
                </div>
              ) : (
                <div>Request a Service</div>
              )}
            </Link>
          </div>
        </div>
      </div>

    {isLoading && <LoadingCover/>}
    </>    
  )
}
